import { render, staticRenderFns } from "./TagOptionsBox.vue?vue&type=template&id=7ef776de&scoped=true&"
import script from "./TagOptionsBox.vue?vue&type=script&lang=js&"
export * from "./TagOptionsBox.vue?vue&type=script&lang=js&"
import style0 from "./TagOptionsBox.vue?vue&type=style&index=0&id=7ef776de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef776de",
  null
  
)

export default component.exports